// Menu deroulant du mobile.
const burger = document.querySelector('.burger');
const nav = document.querySelector('.nav');
burger?.addEventListener('click', () => {
  const ouvert = nav.classList.toggle('ouvert');
  burger.setAttribute('aria-expanded', String(ouvert));
});

// Video Instagram : chargee seulement apres un clic (pas de traceur Meta sans consentement).
document.querySelectorAll('[data-video-insta]').forEach((b) => {
  b.addEventListener('click', () => {
    const zone = b.closest('.video-insta');
    zone.innerHTML = `<blockquote class="instagram-media" data-instgrm-permalink="${b.dataset.videoInsta}"
      data-instgrm-version="14" style="background:#fff;border:1px solid var(--trait);border-radius:14px;margin:0;max-width:540px;min-width:290px;width:100%;padding:0"></blockquote>`;
    const s = document.createElement('script');
    s.async = true; s.src = 'https://www.instagram.com/embed.js';
    document.body.appendChild(s);
  });
});
